import logo from 'assets/header-prevencor-xx.png';
import md5 from 'md5';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import fetchImageBase64 from 'utils/helpers';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

function sectionTitle(text) {
  return {
    text,
    bold: true,
    decoration: 'underline',
    margin: [0, 8, 0, 3],
  };
}

export async function generatePDFTrans({ trans }) {
  const safeTrans = trans || {};
  const textoLaudo = String(safeTrans.ECOTRANS ?? '');
  const logoBase64 = await fetchImageBase64(logo);
  const hashAssinatura = safeTrans.HASH || md5(JSON.stringify(safeTrans));

  const content = [
    {
      text: 'Laudo de Eco Transesofágico',
      bold: true,
      decoration: 'underline',
      alignment: 'center',
      margin: [0, 0, 0, 10],
    },
    {
      text: [
        { text: 'Paciente: ', bold: true },
        `${safeTrans.CODPAC || '-'} - ${safeTrans.NOMEPAC || '-'}`,
      ],
      margin: [0, 0, 0, 1],
    },
    {
      columns: [
        {
          text: [
            { text: 'Sexo: ', bold: true },
            String(safeTrans.SEXOPAC || '-'),
            { text: '   Idade: ', bold: true },
            `${safeTrans.idadePAC ?? '-'} anos`,
          ],
          width: '*',
        },
        {
          text: [
            { text: 'Data do Exame: ', bold: true },
            String(safeTrans.dataTrans || safeTrans.dataFormatada || '-'),
          ],
          width: 'auto',
          alignment: 'right',
        },
      ],
      margin: [0, 1, 0, 1],
    },
    {
      columns: [
        {
          text: [
            { text: 'Médico que Realizou: ', bold: true },
            `Dr.(a): ${safeTrans.Realizou || '-'}`,
          ],
          width: '*',
        },
        {
          text: String(safeTrans.CODTRANS || safeTrans.CODIGO || ''),
          bold: true,
          width: 'auto',
          alignment: 'right',
        },
      ],
      margin: [0, 1, 0, 1],
    },
    {
      text: [
        { text: 'Médico que Solicitou: ', bold: true },
        `Dr.(a): ${safeTrans.Solicitou || '-'}`,
      ],
      margin: [0, 1, 0, 1],
    },
    {
      text: [{ text: 'Convênio: ', bold: true }, String(safeTrans.SIGLACONV || '-')],
      margin: [0, 1, 0, 6],
    },
    {
      canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 0.5 }],
      margin: [0, 0, 0, 6],
    },
    sectionTitle('Descrição'),
    {
      text: textoLaudo || 'Sem descrição preenchida.',
      margin: [10, 0, 0, 1],
    },
    {
      text: 'Conferido e assinado eletronicamente por:',
      italics: true,
      alignment: 'center',
      margin: [0, 20, 0, 3],
    },
    {
      text: `Dr(a).: ${safeTrans.Realizou || '-'}`,
      bold: true,
      alignment: 'center',
      margin: [0, 0, 0, 3],
    },
    {
      text:
        [
          safeTrans.CPFMED ? `CPF: ${safeTrans.CPFMED}` : null,
          safeTrans.CRMMED ? `CRM: ${safeTrans.CRMMED}` : null,
          safeTrans.RQEMED ? `RQE: ${safeTrans.RQEMED}` : null,
        ]
          .filter(Boolean)
          .join(' - ') || '-',
      bold: true,
      alignment: 'center',
      fontSize: 9,
      margin: [0, 0, 0, 3],
    },
    {
      text: `Assinatura Digital: ${hashAssinatura}`,
      bold: true,
      italics: true,
      alignment: 'center',
      fontSize: 9,
      margin: [0, 0, 0, 12],
    },
  ];

  const docDefinition = {
    pageSize: 'A4',
    pageMargins: [40, 90, 40, 68],
    header: () => ({
      stack: [
        {
          image: logoBase64,
          width: 460,
          alignment: 'center',
          margin: [0, 6, 0, 2],
        },
        {
          text: String(safeTrans.CODTRANS || safeTrans.CODIGO || ''),
          bold: true,
          alignment: 'right',
          fontSize: 10,
          margin: [40, 0, 40, 0],
        },
      ],
    }),
    footer: (currentPage, pageCount) => [
      {
        canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 0.5 }],
        margin: [40, 2, 40, 0],
      },
      {
        text: 'Rua Claudio Manuel da Costa, 56 - Fone (14) 3402-2700/Fax: (14) 3402-2705 - Jd Maria Isabel - CEP 17.515-460 - Marilia/SP',
        alignment: 'center',
        fontSize: 7,
        margin: [40, 2, 40, 0],
      },
      {
        text: 'prevencor@unimedmarilia.com.br',
        alignment: 'center',
        fontSize: 7,
        margin: [40, 0, 40, 0],
      },
      {
        text: `Pag: ${currentPage} de ${pageCount}`,
        alignment: 'center',
        fontSize: 8,
        bold: true,
        margin: [40, 1, 40, 0],
      },
    ],
    content,
    defaultStyle: { fontSize: 10 },
  };

  pdfMake.createPdf(docDefinition).open();
  return docDefinition;
}

export default async function gerarPDFTrans(trans) {
  return generatePDFTrans({ trans });
}
